import React from 'react';
import LoaderPayment from '../loader_payment';

interface CardMyHistoryProps {
  img: string;
  title: string;
  value: string | number;
  color: string;
  request: any;
}

const CardMyHistory = (props: CardMyHistoryProps) => {
  const { img, title, value, color, request } = props;
  return (
    <div
      className="card border-top-0 border-right-0 border-bottom-0"
      style={{
        borderLeft: `solid 6px ${color}`,
      }}
    >
      <div className="card-body">
        <img src={img} alt="Calendar" style={{ width: '36px' }} />
        {request.loading ? (
          <LoaderPayment />
        ) : (
          <div>
            <h3 className="mt-3 font-weight-bold">{value}</h3> <p className="mb-0">{title}</p>{' '}
          </div>
        )}
      </div>
    </div>
  );
};

export default CardMyHistory;
